module.exports = __webpack_public_path__ + "static/img/gzhewm.0da8f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/gzhewm.jpg
// module id = 5O6Z
// module chunks = 1